import { useState, useEffect } from 'react';

/**
 * Hook personalizado para detectar si es la primera vez que el usuario visita la aplicación
 * @param {string} key - Clave única para almacenar en localStorage (por defecto: 'hasVisitedFengCart')
 * @returns {[boolean, function]} - Retorna [isFirstVisit, markAsVisited]
 * 
 */
const useFirstVisit = (key = 'hasVisitedFengCart') => {
  const [isFirstVisit, setIsFirstVisit] = useState(false);

  useEffect(() => {
    // Verificar si ya existe el flag en localStorage
    const hasVisited = localStorage.getItem(key);
    
    if (!hasVisited) {
      // Si no existe, es la primera visita
      setIsFirstVisit(true);
    }
  }, [key]);

  /**
   * Marca la visita como completada en localStorage
   */
  const markAsVisited = () => {
    localStorage.setItem(key, 'true');
    setIsFirstVisit(false);
  };

  return [isFirstVisit, markAsVisited];
};

export default useFirstVisit;

